
import { useEffect } from 'react';
import { useLassoTool } from '../../application/lassoToolStore';
import { useMap } from 'react-map-gl';
import DrawControl from './DrawControl';
import React from 'react';
import MapboxDraw from '@mapbox/mapbox-gl-draw';
import FreehandPolygonMode from '../../../../components/property-map-viewer/FreehandPolygon';

export const LassoDrawControl = () => {
  const {
    draw,
    isEnabled,
    selection,
    setSelection,
  } = useLassoTool();

  const { current: map } = useMap();

  useEffect(() => {
    if (!map || !draw) return;

    const currentMode = draw.getMode?.();

    if (isEnabled && currentMode !== 'draw_polygon') {
      draw.changeMode('draw_polygon');
    }

    if (!isEnabled && currentMode !== 'simple_select') {
      draw.changeMode('simple_select');
      // calculatePropertiesInLasso?.();
    }
  }, [ isEnabled, map, draw ]);

  return (
    <DrawControl
      displayControlsDefault={false}
      modes={{
        ...MapboxDraw.modes,
        draw_polygon: FreehandPolygonMode,
      }}
      onCreate={(e) => {
        console.log('DrawControl: onCreate: ', e);
        // Save newly created features
        setSelection(prev => [ ...prev, ...e.features ]);
      }}
      onUpdate={(e) => {
        console.log('DrawControl: onUpdate: ', e);
      }}
      onDelete={(e) => {
        console.log('DrawControl: onDelete: ', e);
        setSelection(prev =>
          prev.filter(feature => !e.features.find(f => f.id === feature.id))
        );
      }}
    />
  );
};
